import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * When paste action is dispatched, this effect handles opening dialog
 */
export const initPaste = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.paste.observe().pipe(
      rxjs.map(sourceAction =>
        plugin.config.clipboardService.paste.from(sourceAction).create({
          dialogConfig: sourceAction.data.dialogConfig,
          paster: plugin.config.pasteClassRef.paster(items => {
            const createAction =
              plugin.collection.plugins.dataOperationPlugin.feature.actions.create.request
                .from(sourceAction)
                // TODO: is the payload actually a create entity? If so, are the
                // types correct to convey this?
                .create({
                  inputs: items.map(item => item.payload),
                })

            return {
              actions: rxjs.of(createAction),
              // TODO: Should we catch errors and cancellation?
              result$:
                plugin.collection.plugins.dataOperationPlugin.feature.actions.create.success
                  .observe()
                  .pipe(
                    rxjs.filter(
                      action => action.requestId === createAction.requestId,
                    ),
                    rxjs.take(1),
                  ),
            }
          }),
        }),
      ),
    ),
)
